import { schema } from 'normalizr';

export const roleNormSchema = new schema.Entity(
  'users',
  {},
  {
    idAttribute: 'name',
  }
);

export const userCardNormSchema = new schema.Entity(
  'userCards',
  {},
  {
    idAttribute: 'uuid',
  }
);

export const userNormSchema = new schema.Entity(
  'users',
  {
    userCard: userCardNormSchema,
    roles: [roleNormSchema],
  },
  {
    idAttribute: 'uuid',
  }
);
